import { Platform } from 'react-native';
import { supabase } from '../../shared/supabase/supabaseClient';

export type ImpersonationContext = {
  sessionId: string;
  staffAuthUserId: string;
  reason: string;
  expiresAt: string;
  organizationId: string | null;
};

/** Parse tolerante — lo reusa el bootstrap (sección `impersonation` embebida). */
export function parseContext(raw: unknown): ImpersonationContext | null {
  if (!raw || typeof raw !== 'object' || Array.isArray(raw)) return null;
  const o = raw as Record<string, unknown>;
  const sessionId = typeof o.session_id === 'string' ? o.session_id : null;
  const staffAuthUserId = typeof o.staff_auth_user_id === 'string' ? o.staff_auth_user_id : null;
  const reason = typeof o.reason === 'string' ? o.reason : null;
  const expiresAt = typeof o.expires_at === 'string' ? o.expires_at : null;
  if (!sessionId || !staffAuthUserId || !reason || !expiresAt) return null;
  return {
    sessionId,
    staffAuthUserId,
    reason,
    expiresAt,
    organizationId: typeof o.organization_id === 'string' ? o.organization_id : null,
  };
}

/** Solo web: la impersonación v1 arranca desde el portal hacia app web. */
export async function fetchActiveImpersonationContext(): Promise<ImpersonationContext | null> {
  if (Platform.OS !== 'web') return null;
  const { data, error } = await supabase.rpc('get_my_active_impersonation_context');
  if (error) {
    console.warn('[impersonation] get_my_active_impersonation_context', error.message);
    return null;
  }
  return parseContext(data);
}

export async function endActiveImpersonationSession(
  endReason: 'manual' | 'expired' = 'manual'
): Promise<void> {
  if (Platform.OS !== 'web') return;
  const { error } = await supabase.rpc('end_my_active_impersonation_session', {
    p_end_reason: endReason,
  });
  if (error) {
    console.warn('[impersonation] end_my_active_impersonation_session', error.message);
  }
}

export function isImpersonationExpired(expiresAt: string, nowMs = Date.now()): boolean {
  const t = Date.parse(expiresAt);
  if (!Number.isFinite(t)) return true;
  return t <= nowMs;
}
